/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="row"
  >
    <div
      class="col-sm-6 col-sm-offset-3"
      aria-labelledby="zoomLoadingPage1"
    >
      <h1 id="zoomLoadingPage1">
        Linking Zoom and VoiceVibes
      </h1>
      <div>
        Please wait while your accounts are linked.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  computed: {
    zoomUrl() {
      return this.$store.getters.appConfig.zoomAuth;
    },
  },
  created() {
    this.$store.dispatch('saveZoomCode', this.$route.query.code)
      .then(() => {
        this.$router.push({ name: 'zoom-recordings' });
      })
      .catch(() => {
        if (window.Raven) {
          window.Raven.captureMessage('saveZoomCode failed to return valid response');
        }
        if (window.confirm('Your Zoom account was unable to be linked to VoiceVibes. Please click OK to try again.')) {
          window.location.href = this.zoomUrl;
        }
      });
  },
};
</script>
